import React from "react";
import { useTranslation } from "react-i18next";
import { Waypoints } from "lucide-react";

import { Card } from "../../components/ui/Card";
import { EmptyState } from "../../components/ui/EmptyState";
import { PendingBackendNotice } from "../../components/ui/PendingBackendNotice";

// Vista desconectada del backend: sin clientes, sin rutas, sin mapa. En vez de
// placeholders con alturas fijas enormes y botones sin handler, dejamos un
// estado compacto y honesto sobre la reconstrucción.
export default function Operation() {
  const { t } = useTranslation();

  return (
    <div className="w-full min-w-0 space-y-3">
      <PendingBackendNotice>
        {t("Planificación de rutas — en construcción.")}
      </PendingBackendNotice>
      <Card padding="none" className="w-full">
        <EmptyState
          icon={<Waypoints />}
          title={t("Planificación no disponible")}
          description={t("La asignación de retiros a rutas y el mapa de planificación están en construcción.")}
        />
      </Card>
    </div>
  );
}
